<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";
import {markRaw} from "vue";

export default {
    name: "doubleBarChart",
    props: {
        id:{
            type: String,
            default:"double_bar_echarts"
        },
        dataList:{
            type: Array,
            default: []
        }
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
        dataList(newValue,oldValue){
            this.chartList = newValue;
            this.init()
        }
    },
    data() {
        return {
            barChart: null,
            chartList:[],
            chartOption:{
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack'] },
                        saveAsImage: { show: true }
                    },
                    position:"left",
                },
                legend: {
                    data: ['当前指数', '参考指数']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        interval: 20,
                    }
                ],
                series: [
                    {
                        name: '当前指数',
                        type: 'bar',
                        barGap: 0,
                        barWidth: '50px',
                        color: [
                            '#67c23a',
                        ],
                        label: {
                            show: true,
                            position:'top'

                        },
                        data: []
                    },
                    {
                        name: '参考指数',
                        type: 'bar',
                        barGap: 0,
                        barWidth: '50px',
                        color: [
                            '#409eff',
                        ],
                        label: {
                            show: true,
                            position:'top'
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.chartList = this.dataList;
            const list = [];
            const listDq = [];//当前指数
            const listCk = [];//参考指数
            if (this.chartList&&this.chartList.length>0){
                this.chartList.forEach(item => {
                    listDq.push(item.index_value);
                    listCk.push(item.ck_index_value);
                    list.push(item.name)
                })
                this.chartOption.xAxis[0].data = list;
                this.chartOption.series[0].data = listDq
                this.chartOption.series[1].data = listCk
            }
            this.barChart = markRaw(echarts.init(document.getElementById(this.id)));
            this.barChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    color: #333!important;
    display: flex;
    > div {
        width: 100%;
        height: 400px;
    }
    div + div {
        margin-left: 10px;
    }
}
</style>